<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="form-group mb-2 coupon" :class="{'coupon-error': codeValidated && !codeValid, 'coupon-success': codeValidated && codeValid}">
                <label :for="identifier" v-if="label">{{ label }} {{ requiredAsterisk }}</label>
                <div class="form-inline">
                    <input
                        type="text"
                        class="form-control mb-2 mb-sm-0 mr-sm-2"
                        :class="{'is-invalid': valid === false || (!codeValid && codeValidated)}"
                        :id="identifier"
                        :name="name"
                        v-model="code"
                        v-bind="$attrs"
                        style="width: 300px; max-width:100%;"
                        @keydown.enter.prevent="validateCode"
                    >
                    <button v-if="!codeValid || !codeValidated" class="btn btn-primary" @click.prevent="validateCode" :disabled="loading">
                        <ButtonLoader v-show="loading" />
                        Code anwenden
                    </button>
                    <button v-if="codeValidated" class="btn btn-link ml-2" @click.prevent="reset">
                        <template v-if="codeValid">Code löschen</template>
                        <template v-else>Abbrechen</template>
                    </button>
                </div>
                <template v-if="codeValidated">
                    <small v-if="codeValid" class="form-text">Der Code wurde erfolgreich angewendet.</small>
                    <small v-else class="form-text">Der Code ist ungültig oder wurde bereits verwendet.</small>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import FormField from "@/mixins/FormField";
import ButtonLoader from "@/components/Loader/ButtonLoader";
import {validateGutscheinCode} from "@/service/validateGutscheinCode";

export default {
    name: 'Gutschein',
    mixins: [FormField],
    components: {ButtonLoader},
    inject: ['settings', 'gutschein', 'setGutschein', 'resetGutschein'],
    props: {
        plz: String,
        tarif_id: Number,
        verbrauch: Number,
    },
    data: () =>({
        code: '',
        codeValid: false,
        codeValidated: false,
        loading: false,
    }),
    mounted() {
        if (this.form && this.form.getValue('gutschein_code')) {
            this.code = this.form.getValue('gutschein_code')
            this.codeValid = this.gutschein.uid !== 0
            this.codeValidated = this.gutschein.uid !== 0
        }
    },
    methods: {
        validateCode() {
            this.loading = true

            validateGutscheinCode(this.settings.gutscheinUrl, this.code, this.plz, this.tarif_id, this.verbrauch)
                .then(res => {
                    this.codeValid = res.success
                    this.updateValue(res.code)
                    return this.setGutschein(res.gutschein)
                })
                .catch(() => {
                    this.codeValid = false
                })
                .finally(() => {
                    this.codeValidated = true
                    this.loading = false
                })
        },
        reset() {
            this.codeValidated = false
            this.codeValid = false
            this.code = ''
            this.updateValue('')
            this.resetGutschein()
        },
        // Override mixin method
        validate() {
            return this.code === '' || this.codeValid;
        }
    },
}
</script>
